import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokonkandarshancabbooking() {



    const cardData = {




keyword: "Mumbai to Konkan Darshan Cab Booking",

headingDescription: "Shreesha Tours & Travels provides reliable and affordable Mumbai to Konkan Darshan cab booking services for families, couples, senior citizens, pilgrims, tourists, and travel groups looking to explore the breathtaking Konkan coastline. We offer one-way cabs, round-trip taxi services, multi-day Konkan Darshan tour packages, and fully customized travel itineraries with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every travel requirement and group size. With doorstep pickup anywhere in Mumbai, flexible travel schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and memorable journey. Whether you are planning a family vacation, coastal road trip, temple tour, beach holiday, honeymoon, photography tour, or sightseeing adventure, our Mumbai to Konkan Darshan cab service offers professional drivers, clean vehicles, and personalized travel plans that let you explore the beauty, culture, beaches, forts, temples, waterfalls, and heritage destinations of the Konkan region at your own pace.",

topPlaces: [
  {
    title: "Ganpatipule",
    description: "Ganpatipule is one of Konkan's most famous pilgrimage and beach destinations, renowned for the self-originated Lord Ganesha Temple located beside the Arabian Sea. The town is also known for its clean beaches, water sports, peaceful surroundings, and spectacular sunsets, making it a perfect destination for families and devotees."
  },
  {
    title: "Tarkarli",
    description: "Tarkarli is a paradise for beach lovers and adventure enthusiasts, famous for its crystal-clear waters, scuba diving, snorkeling, houseboats, dolphin safaris, and white sandy beaches. It is one of Maharashtra's best destinations for marine tourism and coastal holidays."
  },
  {
    title: "Sindhudurg Fort",
    description: "Built by Chhatrapati Shivaji Maharaj, Sindhudurg Fort is one of Maharashtra's most iconic sea forts. Surrounded by the Arabian Sea, the fort showcases remarkable Maratha architecture, historical significance, and panoramic coastal views that attract history lovers and tourists alike."
  },
  {
    title: "Malvan",
    description: "Malvan is a popular coastal town known for its seafood cuisine, pristine beaches, water sports, Sindhudurg Fort, and vibrant Konkan culture. It is an excellent destination for family vacations, beach holidays, and adventure activities."
  },
  {
    title: "Ratnagiri",
    description: "Ratnagiri is a scenic coastal city famous for Alphonso mangoes, beaches, historical monuments, temples, and the birthplace of Lokmanya Bal Gangadhar Tilak. It is a must-visit destination for travelers exploring the Konkan coast."
  },
  {
    title: "Velneshwar Beach",
    description: "Velneshwar Beach is a peaceful and less crowded beach surrounded by coconut groves and natural beauty. It is an ideal destination for travelers seeking relaxation, photography, and a calm coastal atmosphere away from busy tourist locations."
  },
  {
    title: "Harihareshwar",
    description: "Harihareshwar is a sacred coastal town known for the ancient Harihareshwar Temple, beautiful beaches, rocky shoreline, and scenic sea views. It is a favorite destination for pilgrims as well as nature lovers exploring the Konkan region."
  },
  {
    title: "Murud-Janjira Fort",
    description: "Murud-Janjira Fort is one of India's most impressive island forts, famous for its unique architecture, strong fortifications, and fascinating history. Visitors reach the fort by boat while enjoying magnificent views of the Arabian Sea."
  },
  {
    title: "Amboli Hill Station",
    description: "Amboli is a picturesque hill station located near the Konkan region, known for mist-covered valleys, waterfalls, dense forests, and breathtaking viewpoints. It is especially popular during the monsoon season and makes an excellent addition to a Konkan Darshan tour."
  },
  {
    title: "Vengurla",
    description: "Vengurla is a beautiful coastal destination famous for its clean beaches, lighthouse, temples, cashew plantations, and peaceful atmosphere. Its scenic beauty and relaxed environment make it an ideal stop during a Konkan Darshan road trip from Mumbai."
  }
],



"services": [
  {
    "name": "Mumbai to Ganpatipule Cab",
    "description": "Book Mumbai to Ganpatipule Cab for safe, comfortable, and reliable coastal travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for family vacations, beach holidays, and one way or round trip journeys."
  },
  {
    "name": "Mumbai to Ratnagiri Cab",
    "description": "Hire Mumbai to Ratnagiri Cab with experienced drivers, comfortable vehicles, and affordable travel packages for Konkan trips."
  },
  {
    "name": "Mumbai to Tarkarli Cab",
    "description": "Book Mumbai to Tarkarli Cab for relaxing beach holidays with reliable chauffeurs and comfortable AC vehicles."
  },
  {
    "name": "Mumbai to Malvan Cab",
    "description": "Choose Mumbai to Malvan Cab for convenient coastal travel with professional drivers and transparent pricing."
  },
  {
    "name": "Mumbai to Sindhudurg Cab",
    "description": "Reserve Mumbai to Sindhudurg Cab for comfortable outstation travel with clean vehicles and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Devgad Cab",
    "description": "Book Mumbai to Devgad Cab with affordable fares and reliable long-distance transportation."
  },
  {
    "name": "Mumbai to Dapoli Cab",
    "description": "Hire Mumbai to Dapoli Cab for weekend getaways with comfortable vehicles and flexible travel schedules."
  },
  {
    "name": "Mumbai to Harihareshwar Cab",
    "description": "Choose Mumbai to Harihareshwar Cab for peaceful beach and temple travel with professional chauffeur service."
  },
  {
    "name": "Mumbai to Guhagar Cab",
    "description": "Book Mumbai to Guhagar Cab with premium AC vehicles and experienced drivers for a comfortable journey."
  },
  {
    "name": "Mumbai to Kunkeshwar Cab",
    "description": "Reserve Mumbai to Kunkeshwar Cab for convenient temple and beach travel with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Velneshwar Cab",
    "description": "Hire Mumbai to Velneshwar Cab for smooth coastal travel with comfortable seating and affordable fares."
  },
  {
    "name": "Mumbai to Hedvi Cab",
    "description": "Book Mumbai to Hedvi Cab with experienced drivers and clean AC vehicles for a safe journey."
  },
  {
    "name": "Mumbai to Diveagar Cab",
    "description": "Choose Mumbai to Diveagar Cab for family beach holidays with spacious vehicles and flexible travel plans."
  },
  {
    "name": "Mumbai to Shrivardhan Cab",
    "description": "Reserve Mumbai to Shrivardhan Cab with reliable chauffeurs and comfortable outstation transportation."
  },
  {
    "name": "Mumbai to Vijaydurg Cab",
    "description": "Book Mumbai to Vijaydurg Cab for heritage and coastal sightseeing with affordable travel packages."
  },
  {
    "name": "Mumbai to Konkan Darshan Cab",
    "description": "Book Mumbai to Konkan Darshan Cab for a complete Konkan sightseeing experience with professional chauffeurs and comfortable vehicles."
  },
  {
    "name": "Mumbai to Konkan Darshan Taxi",
    "description": "Choose Mumbai to Konkan Darshan Taxi with reliable drivers and premium vehicles for memorable coastal tours."
  },
  {
    "name": "Mumbai to Konkan Tour Cab",
    "description": "Reserve Mumbai to Konkan Tour Cab with customized itineraries and comfortable chauffeur-driven travel."
  },
  {
    "name": "Mumbai to Konkan Taxi Service",
    "description": "Hire Mumbai to Konkan Taxi Service with affordable pricing and flexible one way or round trip options."
  },
  {
    "name": "Mumbai to Konkan Cab Service",
    "description": "Book Mumbai to Konkan Cab Service with experienced chauffeurs and clean AC vehicles for hassle-free travel."
  },
  {
    "name": "Mumbai to Konkan Car Rental",
    "description": "Choose Mumbai to Konkan Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles."
  },
  {
    "name": "Mumbai to Konkan Cabs",
    "description": "Reserve Mumbai to Konkan Cabs for safe family trips, holiday tours, and long-distance coastal travel."
  },
  {
    "name": "Konkan Darshan Cab Booking",
    "description": "Complete Konkan Darshan Cab Booking online with instant confirmation and multiple vehicle choices."
  },
  {
    "name": "Konkan Tour Taxi",
    "description": "Book Konkan Tour Taxi with comfortable vehicles and professional chauffeurs for sightseeing across the Konkan region."
  },
  {
    "name": "Mumbai Konkan Tour Package by Cab",
    "description": "Choose Mumbai Konkan Tour Package by Cab with customized routes, comfortable vehicles, and experienced drivers."
  },
  {
    "name": "Konkan Darshan Tour by Cab",
    "description": "Book Konkan Darshan Tour by Cab for a convenient multi-destination coastal tour with reliable transportation."
  },
  {
    "name": "Konkan Road Trip Cab",
    "description": "Reserve Konkan Road Trip Cab for scenic highway journeys with premium chauffeur-driven vehicles."
  },
  {
    "name": "Konkan Family Tour by Taxi",
    "description": "Choose Konkan Family Tour by Taxi with spacious AC vehicles for enjoyable family vacations."
  },
  {
    "name": "Konkan Holiday Cab",
    "description": "Book Konkan Holiday Cab for beach holidays, sightseeing, and comfortable long-distance travel."
  },
  {
    "name": "Mumbai to Konkan Sightseeing Cab",
    "description": "Hire Mumbai to Konkan Sightseeing Cab for exploring beaches, temples, forts, and popular tourist attractions."
  },
  {
    "name": "Konkan Beach Tour Cab",
    "description": "Book Konkan Beach Tour Cab with flexible sightseeing plans and experienced chauffeurs."
  },
  {
    "name": "Weekend Konkan Trip by Cab",
    "description": "Reserve Weekend Konkan Trip by Cab with affordable travel packages and comfortable vehicles."
  },
  {
    "name": "Mumbai to Konkan Round Trip Cab",
    "description": "Choose Mumbai to Konkan Round Trip Cab with economical return packages and reliable chauffeur service."
  },
  {
    "name": "Konkan Tourist Taxi",
    "description": "Hire Konkan Tourist Taxi for sightseeing, beach holidays, and comfortable intercity transportation."
  },
  {
    "name": "Innova Crysta for Konkan Darshan",
    "description": "Book Innova Crysta for Konkan Darshan for premium family travel with spacious seating and luxury comfort."
  },
  {
    "name": "Innova Cab Mumbai to Konkan",
    "description": "Reserve Innova Cab Mumbai to Konkan for comfortable group travel with experienced chauffeurs."
  },
  {
    "name": "Ertiga Cab for Konkan Tour",
    "description": "Choose Ertiga Cab for Konkan Tour for affordable 6 to 7 seater family travel."
  },
  {
    "name": "SUV Cab Mumbai to Konkan",
    "description": "Book SUV Cab Mumbai to Konkan with spacious seating and additional luggage capacity for long journeys."
  },
  {
    "name": "Sedan Cab Mumbai to Konkan",
    "description": "Hire Sedan Cab Mumbai to Konkan for economical and comfortable coastal travel."
  },
  {
    "name": "Kia Carens Konkan Tour",
    "description": "Reserve Kia Carens Konkan Tour for modern family travel with premium comfort and spacious interiors."
  },
  {
    "name": "Tempo Traveller for Konkan Tour",
    "description": "Book Tempo Traveller for Konkan Tour for group vacations, corporate outings, and family sightseeing with comfortable seating."
  }
],
"tableData": [
  ["Mumbai to Ganpatipule Cab", "Mumbai to Ratnagiri Cab"],
  ["Mumbai to Tarkarli Cab", "Mumbai to Malvan Cab"],
  ["Mumbai to Sindhudurg Cab", "Mumbai to Devgad Cab"],
  ["Mumbai to Dapoli Cab", "Mumbai to Harihareshwar Cab"],
  ["Mumbai to Guhagar Cab", "Mumbai to Kunkeshwar Cab"],
  ["Mumbai to Velneshwar Cab", "Mumbai to Hedvi Cab"],
  ["Mumbai to Diveagar Cab", "Mumbai to Shrivardhan Cab"],
  ["Mumbai to Vijaydurg Cab", "Mumbai to Konkan Darshan Cab"],
  ["Mumbai to Konkan Darshan Taxi", "Mumbai to Konkan Tour Cab"],
  ["Mumbai to Konkan Taxi Service", "Mumbai to Konkan Cab Service"],
  ["Mumbai to Konkan Car Rental", "Mumbai to Konkan Cabs"],
  ["Konkan Darshan Cab Booking", "Konkan Tour Taxi"],
  ["Mumbai Konkan Tour Package by Cab", "Konkan Darshan Tour by Cab"],
  ["Konkan Road Trip Cab", "Konkan Family Tour by Taxi"],
  ["Konkan Holiday Cab", "Mumbai to Konkan Sightseeing Cab"],
  ["Konkan Beach Tour Cab", "Weekend Konkan Trip by Cab"],
  ["Mumbai to Konkan Round Trip Cab", "Konkan Tourist Taxi"],
  ["Innova Crysta for Konkan Darshan", "Innova Cab Mumbai to Konkan"],
  ["Ertiga Cab for Konkan Tour", "SUV Cab Mumbai to Konkan"],
  ["Sedan Cab Mumbai to Konkan", "Kia Carens Konkan Tour"],
  ["Tempo Traveller for Konkan Tour", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Konkan Darshan Cab Booking",
    WhyChoosedescription: "Shreesha Tours & Travels offers comfortable Mumbai to Konkan Darshan cab services with experienced chauffeurs and well-maintained vehicles for a memorable coastal road trip."
  },
  {
    WhyChooseheading: "Customized Konkan Tour Packages",
    WhyChoosedescription: "Plan your Konkan journey according to your preferences by covering destinations such as Ganpatipule, Ratnagiri, Tarkarli, Sindhudurg, Malvan, Kunkeshwar, Velneshwar, Devgad, Harihareshwar, Dapoli, and other scenic locations."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Group",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles suitable for solo travellers, families, couples, and large groups."
  },
  {
    WhyChooseheading: "Flexible One Way & Multi-Day Tours",
    WhyChoosedescription: "Book one-way transfers, round trips, weekend getaways, or customized multi-day Konkan Darshan packages with flexible pickup and return schedules."
  },
  {
    WhyChooseheading: "Professional Drivers with Coastal Route Experience",
    WhyChoosedescription: "Our trained chauffeurs are familiar with Konkan highways, ghat roads, and coastal destinations, ensuring a safe, smooth, and enjoyable journey."
  },
  {
    WhyChooseheading: "Perfect for Holidays & Pilgrimage",
    WhyChoosedescription: "Whether you're planning a beach vacation, temple tour, photography trip, family holiday, honeymoon, or a relaxing coastal escape, our cab service is an ideal choice."
  },
  {
    WhyChooseheading: "Clean, Spacious & Well-Maintained Fleet",
    WhyChoosedescription: "Travel in air-conditioned vehicles with comfortable seating, clean interiors, and ample luggage space, making long-distance coastal travel pleasant and convenient."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai to Konkan Darshan cab quickly with transparent pricing, prompt customer support, and personalized travel assistance from start to finish."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Konkan Darshan Cab Booking?",
    answer: "Yes, we provide private cab services from Mumbai for Konkan Darshan tours with customized travel itineraries."
  },
  {
    question: "Which destinations can be covered in the Konkan Darshan tour?",
    answer: "You can visit destinations like Ganpatipule, Ratnagiri, Malvan, Tarkarli, Sindhudurg Fort, Devgad, Kunkeshwar, Velneshwar, Harihareshwar, Dapoli, and other Konkan attractions."
  },
  {
    question: "Which vehicles are available for Konkan Darshan trips?",
    answer: "We offer Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for comfortable travel."
  },
  {
    question: "Can I customize my Konkan Darshan itinerary?",
    answer: "Yes, you can choose your destinations, travel duration, sightseeing stops, and overnight stays according to your travel plans."
  },
  {
    question: "Do you provide one-way and round-trip cab services?",
    answer: "Yes, one-way, round-trip, and multi-day Konkan tour packages are available with flexible schedules."
  },
  {
    question: "Is the Konkan Darshan cab suitable for family vacations?",
    answer: "Yes, our spacious vehicles are perfect for families, friends, couples, senior citizens, and group tours."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are tolls, parking, and permits included in the fare?",
    answer: "Toll charges, parking fees, permits, and other applicable expenses depend on the selected tour package and are explained before booking."
  },
  {
    question: "Is Mumbai to Konkan Darshan cab service available throughout the year?",
    answer: "Yes, Shreesha Tours & Travels provides Konkan tour cab services throughout the year, subject to advance booking and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Konkan Darshan Cab?",
    answer: "Share your travel date, pickup location, preferred destinations, number of passengers, tour duration, and vehicle preference to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Naik",
    feedback: "Our Konkan Darshan trip with Shreesha Tours & Travels was an unforgettable experience. The cab was comfortable, the driver was friendly, and every destination was covered as planned.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patwardhan",
    feedback: "We booked an Innova Crysta for our family Konkan tour. The vehicle was clean, spacious, and the entire journey along the coastal route was smooth and enjoyable. Highly recommended.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab Booking",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-konkan-darshan-cab-booking.webp",
  "description":
    "Book Mumbai to Konkan Darshan Cab Booking with Shreesha Tours & Travels for safe, comfortable, and affordable Konkan tour packages. We provide one-way and round-trip cabs from Mumbai to Ganpatipule, Ratnagiri, Tarkarli, and other Konkan destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for family vacations, beach holidays, sightseeing, and customized tour packages.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-konkan-darshan-cab-booking"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Konkan Darshan Cab Booking | Coastal Tour Package | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Konkan Darshan Cab Booking with Shreesha Travels for reliable Konkan tour packages. Visit Ganpatipule, Ratnagiri, Tarkarli, and other scenic destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Mumbai to Konkan Darshan Cab Booking, Mumbai to Ganpatipule Cab, Mumbai to Ratnagiri Cab, Mumbai to Tarkarli Cab, Mumbai Konkan Tour Package, Mumbai to Konkan Taxi Service, Mumbai to Konkan Cab Service, Mumbai Konkan Darshan Tour, Mumbai to Konkan Car Rental, Mumbai Konkan Sightseeing Cab, Mumbai to Konkan Outstation Cab, Konkan Tour Cab from Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitokonkandarshancabbooking;